import { Initialize } from "@warda/library-ui/interfaces";
import { getQueryParams } from "../../searchString";
const getFilesWs = ({ oldIds, newIds, files, init, }) => {
    const { hrch, prnt } = getQueryParams();
    const newArray = Array.from(oldIds);
    newIds.forEach((f) => newArray.push(f));
    const ids = newArray.filter((f) => {
        // idsWs potrebbe non avere hrch e prnt
        // in questi casi è un'operazione di UPDATE e quindi
        // devo controllare se tale item è presente nel content
        if (f.hrch === undefined || f.prnt === undefined) {
            const isInContent = files.find((a) => f.id === a.id);
            return isInContent;
        }
        else {
            const isThisFolder = f.hrch === hrch && f.prnt === prnt;
            return isThisFolder;
        }
    });
    return {
        ids,
        init: ids.length > 0 ? Initialize.START : init,
    };
};
export default getFilesWs;
